/* eslint no-console: 0 */

import MarkdownScript from 'helpers/markdownScript';
import metadataFile from './index.md';
import extensionActivitiesFile from './extensionActivities/extensionActivities.md';
import programPrepFile from './programPrep/programPrep.md';
import level1Prepfile from './sections/00_prep/level1_prep.md';
import level2Prepfile from './sections/00_prep/level2_prep.md';
import level3Prepfile from './sections/00_prep/level3_prep.md';
import level4Prepfile from './sections/00_prep/level4_prep.md';
import level5Prepfile from './sections/00_prep/level5_prep.md';
import level6Prepfile from './sections/00_prep/level6_prep.md';
import funFile from './fun.md';
import imageThumb from './images/zeroHeroes.png';
import trialImageThumb from './images/zeroHeroesTrial.png';
import expiredImageThumb from './images/zeroHeroesExpired.png';
import config from './config';

// Preload image functions
import { preloadGameShow } from './sections/20_gameShow/gameShowSection';

import './theme.scss';

const md = new MarkdownScript(metadataFile);

const levels = {
  prep: {
    deck: require('./levelPrep')
  },
  1: {
    thumbnail: require('./images/level-1_start.png'),
    overviewThumbnail: require('./images/overview/level-1_start.png'),
    deck: require('./level1'),
    prep: new MarkdownScript(level1Prepfile),
    levelName: 'Operation Garbage Watch'
  },
  2: {
    thumbnail: require('./images/level-2_start.png'),
    overviewThumbnail: require('./images/overview/level-2_start.png'),
    deck: require('./level2'),
    prep: new MarkdownScript(level2Prepfile),
    levelName: 'Operation Love Food, Hate Waste'
  },
  3: {
    thumbnail: require('./images/level-3_start.png'),
    overviewThumbnail: require('./images/overview/level-3_start.png'),
    deck: require('./level3'),
    prep: new MarkdownScript(level3Prepfile),
    levelName: 'Operation Food Scraps'
  },
  4: {
    thumbnail: require('./images/level-4_start.png'),
    overviewThumbnail: require('./images/overview/level-4_start.png'),
    deck: require('./level4'),
    prep: new MarkdownScript(level4Prepfile),
    levelName: 'Operation Waste-Free Lunch'
  },
  5: {
    thumbnail: require('./images/level-5_start.png'),
    overviewThumbnail: require('./images/overview/level-5_start.png'),
    deck: require('./level5'),
    prep: new MarkdownScript(level5Prepfile),
    levelName: 'Operation Buy Smart'
  },
  6: {
    thumbnail: require('./images/level-6_start.png'),
    overviewThumbnail: require('./images/overview/level-6_start.png'),
    deck: require('./level6'),
    prep: new MarkdownScript(level6Prepfile),
    levelName: 'Operation Green Cycle'
  },
  completed: {
    deck: require('./levelCompleted')
  }
};

const program = {
  id: 'zeroHeroes',
  title: md.getSectionAsString('Title - Short'),
  longTitle: md.getSectionAsString('Title - Long'),
  thumbnailImage: imageThumb,
  trialImageThumb,
  expiredImageThumb,
  longDescription: md.getSectionAsString('Description - Long'),
  levelsDescription: md.getSectionAsString('Description - Levels'),
  shortDescription: md.getSectionAsString('Description - Short'),
  levels,
  extensionActivitiesMd: new MarkdownScript(extensionActivitiesFile),
  programPrepMd: new MarkdownScript(programPrepFile),
  funMd: new MarkdownScript(funFile),
  preload: ({ level }) => {
    console.log(`Preloading assets for Level ${level}`);

    preloadGameShow();
  },
  config
};

export default program;



// WEBPACK FOOTER //
// ./programs/zeroHeroes/index.js